
/* injects from baggage-loader */

'use strict';

import AccountDashboardController from './account.dashboard.controller';
import AccountDashboardTemplate from './account.dashboard.html';

export default class AccountDashboardComponent {
		constructor() {
				this.templateUrl = AccountDashboardTemplate;
				this.controller = AccountDashboardController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					company: '<',
					events: '<',
					pendingDocumentRequestsCount: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/dashboard/account.dashboard.component.js